const prodAccordionArrow = () => {
    const accordions = document.querySelectorAll('.product__accordion__title');
    accordions.forEach(accordion => {
        accordion.addEventListener('click', () => {
            accordion.classList.toggle('rotate-arrow');
        })
    })
}
document.addEventListener("DOMContentLoaded", function () {
    if(document.querySelector('.product__accordions')) {
        prodAccordionArrow();
    };
});

const hideExpWorkshop = () => {
    const prodGridItems = document.querySelectorAll('.product-grid-item');
    const currentDate = new Date();
    // const currentDate = new Date('Wed Dec 14 2024 19:00:00 GMT-0500 (Eastern Standard Time)');
    currentDate.setHours(0, 0, 0, 0);
    // console.log(currentDate)

    prodGridItems.forEach(item => {
        const prodDate = item.querySelector('.product-date');
        if (prodDate) {
            let prodDateArr = prodDate.getAttribute('data-date').split(', ');
            if (prodDateArr.length > 1) {
                let prodDateArrObj = prodDateArr.map(date => new Date(Date.parse(date + "T00:00:00")));
                // console.log(prodDateArrObj)
                if (prodDateArrObj.every(date => date < currentDate)) {
                    item.style.display = 'none';
                }
            } else {
                const prodDateObj = new Date(Date.parse(prodDate.getAttribute('data-date') + "T00:00:00"));
                // console.log(prodDateObj)
                if (prodDateObj < currentDate) {
                    item.style.display = 'none';
                }
            }
        }
    });
};
document.addEventListener("DOMContentLoaded", function () {
    if(document.querySelector('.featured-collection')) {
        hideExpWorkshop();
    };
});

const updateAddToCartBtnPrice = () => {
    const subscriptionLabel = document.querySelectorAll('.shopify_subscriptions_app_block_label label');
    const productPrice = document.querySelector('.product__form__wrapper .product__price');

    subscriptionLabel.forEach(label => {
        label.addEventListener('click', () => {
            let dataPrice = label.querySelector('input').getAttribute('data-variant-price').replace(' USD', '');
            productPrice.innerText = dataPrice;        
        })
    })
}

const pdpTextInput = () => {
    const textArea = document.querySelector('.product-single .line-item-property__field textarea');
    const btnSubmit = document.querySelector('.product-single .btn--submit');
    const btnCtr = document.querySelector('.product-single .product__submit__item:not(.popup-quick-view__item .product__submit__item');
    const label = document.querySelector('label[for="greeting-card-note"]');

    if (textArea) {
        btnSubmit.classList.add('btn--disabled');

        textArea.addEventListener('input', () => {
            if(textArea.value.trim() !== "") {
                btnSubmit.classList.remove('btn--disabled');
                label.style.color = '#000';
            } else {
                btnSubmit.classList.add('btn--disabled');
            }
        });

        if(textArea.value == "No note required") {
            btnSubmit.classList.remove('btn--disabled');
        };

        btnCtr.addEventListener('click', () => {
            if(btnSubmit.classList.contains('btn--disabled')) {
                label.style.color = 'red';
            }
        });
    };

}
document.addEventListener("DOMContentLoaded", function () {
    if(document.querySelector('.product-single')) {
        updateAddToCartBtnPrice();
        pdpTextInput();
    };
});

const imageGallery = () => {
    const sections = document.querySelectorAll(".shopify-section--images-gallery");
    
    for (let i = 1; i < sections.length; i++) {
        sections[i].style.display = "none";
    }

    sections.forEach((section, index) => {
        const button = section.querySelector(".images-gallery__button");
        if (button) {
            button.addEventListener("click", function(e) {
                e.preventDefault();
                if (sections[index + 1]) {
                    sections[index + 1].style.display = "block";
                }
                button.style.display = "none";
            });
        }
    });
}
document.addEventListener("DOMContentLoaded", function () {
    if(document.querySelector('#weddings-gallery')) {
        imageGallery();
    };
});


// document.getElementById('workshops-select').addEventListener('change', function (e) {

//   if (e.target.value === "All") {
//     document.querySelector(".ChagrinFalls").style.display = 'block';
//     document.querySelector(".Columbus").style.display = 'block';
//     document.querySelector(".Lakewood").style.display = 'block';
//   }

  
//   if (document.querySelector('.Columbus') !== null) {
//     if (e.target.value === "Columbus") {
//       document.querySelector(".Columbus").style.display = 'block';
//       document.querySelector(".Lakewood").style.display = 'none';
//       document.querySelector(".ChagrinFalls").style.display = 'none';
//       document.querySelector(".Columbus.ChagrinFalls").style.display = 'block';
//       document.querySelector(".Columbus.Lakewood").style.display = 'block';
//     }
//   } 
//   else {
//     document.querySelector(".Lakewood").style.display = 'none';
//     document.querySelector(".ChagrinFalls").style.display = 'none';
//     document.querySelector(".ChagrinFalls.Lakewood").style.display = 'none';
//   }
  

//   if (e.target.value === "Lakewood") {
//     document.querySelector(".Lakewood").style.display = 'block';
//     document.querySelector(".Columbus").style.display = 'none';
//     document.querySelector(".ChagrinFalls").style.display = 'none';
//     document.querySelector(".ChagrinFalls.Lakewood").style.display = 'block';
//     document.querySelector(".Columbus.Lakewood").style.display = 'block';
//   }

//   if (e.target.value === "ChagrinFalls") {
//     document.querySelector(".ChagrinFalls").style.display = 'block';
//     document.querySelector(".Columbus").style.display = 'none';
//     document.querySelector(".Lakewood").style.display = 'none';
//     document.querySelector(".ChagrinFalls.Lakewood").style.display = 'block';
//     document.querySelector(".ChagrinFalls.Columbus").style.display = 'block';
//   }
  
// });


const workShopFilter = () => {
    const selector = document.querySelector('#workshops-select');
    const workShopItems = document.querySelectorAll('.product-grid-item');

    selector.addEventListener('change', (event) => {
        if(event.target.value === 'All') {
            workShopItems.forEach(item => {
                item.style.display = 'block';
            })
        } else {
            workShopItems.forEach(item => {
                let locations = item.getAttribute('data-location');
                if(locations) {
                    let locationsArr = locations.split(', ');
                    // console.log(locationsArr)
                    // console.log(event.target.value)
                    if(locationsArr.includes(event.target.value)) {
                        item.style.display = 'block';
                    } else {
                        item.style.display = 'none'
                    }
                }
            })
        }        
        hideExpWorkshop();
    })

}
document.addEventListener("DOMContentLoaded", function () {
    if(document.querySelector('#workshops-select')) {
        workShopFilter();
    };
});